<template>
    <div class="flowContainerWithXml" ref="flowPreviewContainer" :style="{height: height+'px'}">
        <div class="canvas" ref="canvas"></div>
    </div>
</template>
<script>
import BpmnViewer from 'bpmn-js/lib/Viewer';
import 'bpmn-js/dist/assets/diagram-js.css';
import 'bpmn-js/dist/assets/bpmn-font/css/bpmn-embedded.css';
export default {
    name: 'flowContainerWithXml',
    props: {
        xml: {
            required: true,
        },
        height: {
            required: false,
            default: 200
        }
    },
    watch:{
        'xml':function(newValue, oldValue){
            // if(newValue != undefined && newValue != ""){
                this.create(newValue)
            // }
        }
    },
    data(){
        return {
            bpmnModeler: null,
            container: null,
            canvas: null
        }
    },
    methods: {
        create: function () {
            let that = this
            this.bpmnModeler && this.bpmnModeler.destroy();
            this.scale = 1;
            this.bpmnModeler = new BpmnViewer({container: this.$refs['canvas']});
            const viewer = this.bpmnModeler;
            this.bpmnModeler.importXML(this.xml, (err) => {
                if (err) {
                    // that.$Message.error('预览流程失败!');
                } else {
                    viewer.get('canvas').zoom('fit-viewport');
                }
            });
    
        }
    }
}
</script>
<style scoped>
    .flowContainerWithXml .canvas{
        width: 100%;
        height: 100%;
    }
</style>